import Vue from 'vue'
import Vuex from 'vuex'
import env from './modules/env'
import ui from './modules/ui'
import data from './modules/data'
import auth from './modules/auth'
import setting from './modules/setting'
import payment from './modules/payment'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    env,
    ui,
    data,
    auth,
    setting,
    payment
  },
  getters
})

export default store
